export enum EStaticPage {
  PrivacyPolicy = 1,
  LegalNotice = 2,
  TermsAndConditions = 3,
  CookiePolicy = 4,
  Contact = 5,
  Welcome = 6,
  HowToOrder = 7,
}
